// @flow
const defaultState = {
  authentication: {
    token: '',
    isFetching: false,
    error: null,
    isLoggedIn: false,
    tokenContent: {},
    user: {}
  },
  organisations: [],
  locations: [],
  customers: [],
  shapeSets: [],
  insightSets: [],
  industries: [],
  users: [],
  settings: {},

  activeOrganisation: {
    // ...details,
    name: undefined,
    industryId: undefined,
    phone: undefined,
    address: undefined,
    abn: undefined,
    acn: undefined,
    organisationTypeId: undefined,
    canSendToNoJunkMail: false,
    canSendToDoNotMail: false,
    referenceNo: undefined,
    settings: {}
  },

  currentOrganisation: {
    // ...details,
    name: undefined,
    industryId: undefined,
    phone: undefined,
    address: undefined,
    abn: undefined,
    acn: undefined,
    organisationTypeId: undefined,
    referenceNo: undefined,
    canSendToNoJunkMail: false,
    canSendToDoNotMail: false,

    locations: [],
    settings: {},
    campaigns: [],
    users: {
      allocated: [],
      unallocated: []
    },
    shapeSets: {
      allocated: [],
      unallocated: []
    },
    insightSets: {
      allocated: [],
      unallocated: []
    },
    permissions: [],
    userSettings: {
      availablePermissions: []
    }
  },

  currentLocation: {
    // ...details,
    settings: {},
    users: {
      allocated: [],
      unallocated: []
    },
    shapeSets: [],
    insightSets: [],
    campaigns: [],
    agencies: [],
    permissions: []
  },

  currentShapeSet: {
    // ...details,
    id: undefined,
    name: undefined,
    dateCreated: undefined,
    dateUpdated: undefined,
    lastChangedBy: undefined,
    isArchived: false,
    shapeSetTypeId: undefined,
    shareWithAllIndustries: false,
    createdBy: undefined,
    isOwner: undefined,
    downloadUrl: undefined,

    industries: {
      allocated: [],
      unallocated: []
    },
    organisations: {
      allocated: [],
      unallocated: []
    },
    settings: {
      shapeSetType: []
    }
  },

  currentInsightSet: {
    // ...details,
    id: undefined,
    name: undefined,
    information: undefined,
    isArchived: false,
    insightSetTypeId: undefined,
    shareWithAllIndustries: false,
    createdBy: undefined,
    lastChangedBy: undefined,
    dateCreated: undefined,
    dateUpdated: undefined,
    inheritedFromIndustry: undefined,
    membershipId: undefined,

    industries: {
      allocated: [],
      unallocated: []
    },
    organisations: {
      allocated: [],
      unallocated: []
    },
    insights: {
      allocated: [],
      unallocated: []
    },
    settings: {
      insightSetType: []
    }
  },

  currentIndustry: {
    // ...details,
    id: undefined,
    name: undefined,
    isArchived: false,
    createdBy: undefined,
    lastChangedBy: undefined,
    dateCreated: undefined,
    dateUpdated: undefined,

    insightSets: {
      allocated: [],
      unallocated: []
    },
    shapeSets: {
      allocated: [],
      unallocated: []
    },
    organisations: {
      allocated: [],
      unallocated: []
    }
  },
  currentReferenceLayer: {
    id: undefined,
    label: undefined,
    version: undefined,
    referenceLayerTypeId: undefined,
    visibilityTypeId: undefined,
    refName: undefined,
    attribution: undefined,
    sortOrder: undefined,
    dateCreated: undefined,
    dateUpdated: undefined,
    createdBy: undefined,
    lastChangedBy: undefined,
    isArchived: undefined,
    description: undefined
  },

  currentBooking: {
    id: undefined,
    bookingNumber: undefined,
    bookingId: undefined,
    dateCreated: undefined,
    dateUpdated: undefined,
    userId: undefined,
    organisationId: undefined,
    totalNumberOfRecordsSaved: undefined,
    dateBookingLodgedBy: undefined,
    campaignName: undefined,
    organisationName: undefined,
    userName: undefined
  },

  currentCampaignBooking: {
    id: undefined,
    bookingNumber: undefined,
    bookingId: undefined,
    dateCreated: undefined,
    dateUpdated: undefined,
    userId: undefined,
    campaignId: undefined,
    organisationId: undefined,
    totalNumberOfRecordsSaved: undefined,
    dateBookingLodgedBy: undefined
  },

  currentCampaign: {
    id: undefined,
    name: undefined,
    organisationOwnerId: undefined,
    dateCreated: undefined,
    dateUpdated: undefined,
    lastChangedBy: undefined,
    statusTypeId: undefined,
    isArchived: undefined,
    notes: undefined,
    targetTypeId: undefined,
    address: undefined,
    locationShapeSetId: undefined,
    createdBy: undefined,
    details: {
      mdsObject: {
        radiusSelection: undefined
      }
    },
    insightSetId: undefined,
    boundaryOverlapTypeId: undefined,
    insightId: undefined,
    organisationOwnerName: undefined,
    canSendToNoJunkMail: false,
    canSendToDoNotMail: false,
    settings: {
      campaignStatus: [],
      boundaryOverlaps: [],
      targets: [],
      radiusSelection: []
    }
  },

  currentUser: {
    id: undefined,
    name: undefined,
    email: undefined,
    phone: undefined,
    isArchived: false,
    isPendingInvitation: undefined,
    isSuperUser: false,
    createdBy: undefined,
    lastChangedBy: undefined,
    dateCreated: undefined,
    dateUpdated: undefined,
    permissions: [],
    settings: {
      availablePermissions: []
    },
    organisations: {}
  },

  currentCustomer: {
    // ...details,
    name: undefined,
    id: undefined,
    industryId: 0,
    phone: undefined,
    address: undefined,
    abn: undefined,
    acn: undefined,
    organisationTypeId: undefined,
    referenceNo: undefined,
    canSendToNoJunkMail: false,
    canSendToDoNotMail: false,

    locations: [],
    settings: {},
    campaigns: [],
    users: {
      allocated: [],
      unallocated: []
    },
    shapeSets: {
      allocated: [],
      unallocated: []
    },
    insightSets: {
      allocated: [],
      unallocated: []
    },
    agencies: [],
    agencySettings: {
      unallocatedAgencies: [],
      availablePermissions: []
    },
    currentLocation: {
      // ...details
      name: undefined,
      industryId: undefined,
      phone: undefined,
      address: undefined,
      abn: undefined,
      acn: undefined,
      organisationTypeId: undefined,
      referenceNo: undefined,
      isArchived: false
    }
  }
};

export default defaultState;

// InsightSetTags?



// WEBPACK FOOTER //
// ./src/defaultState.js